/** Allowed `productCardSize` values — keep in sync with backend MenuV2 schema and client Menu. */

export const PRODUCT_CARD_SIZES = ["small", "normal", "big"];

export function normalizeProductCardSize(value) {
  return PRODUCT_CARD_SIZES.includes(value) ? value : "normal";
}
